"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lobby = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const company_settings_1 = require("../context/company_settings");
const invitation_details_1 = require("../context/invitation_details");
const room_session_1 = require("../context/room_session");
const use_lobby_on_init_1 = require("../hooks/use_lobby_on_init");
const call_lobby_1 = require("../components/lobby/call_lobby");
function Lobby({ invitationDetails, companySettings, hostRoomSession, startCall, onInit, }) {
    // TODO: create 'userSessionProvider'
    const CompanySettingsProvider = (0, company_settings_1.createCompanySettingsProvider)(companySettings);
    const InvitationDetailsProvider = (0, invitation_details_1.createInvitationDetailsProvider)(invitationDetails);
    const HostRoomSessionProvider = (0, room_session_1.createRoomSessionProvider)(hostRoomSession);
    const initialized = (0, use_lobby_on_init_1.useLobbyOnInit)(onInit);
    return ((0, jsx_runtime_1.jsx)(CompanySettingsProvider, { children: (0, jsx_runtime_1.jsx)(InvitationDetailsProvider, { children: (0, jsx_runtime_1.jsx)(HostRoomSessionProvider, { children: (0, jsx_runtime_1.jsx)(call_lobby_1.CallLobby, { startCall: startCall, initialized: initialized }) }) }) }));
}
exports.Lobby = Lobby;
//# sourceMappingURL=lobby.js.map